/**
 * Web Style Import
 *
 */

import './style/dnb-country-flag.scss'
